import { useEffect, useState } from "react";

export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

const UTM_STORAGE_KEY = "immovox_utm_params";

export const useUtmParams = () => {
  const [utmParams, setUtmParams] = useState<UtmParams>({});

  useEffect(() => {
    // Check URL for UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    const newUtmParams: UtmParams = {};

    const utmKeys: (keyof UtmParams)[] = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];

    utmKeys.forEach((key) => {
      const value = urlParams.get(key);
      if (value) {
        newUtmParams[key] = value;
      }
    });

    // If we found UTM params in URL, store them
    if (Object.keys(newUtmParams).length > 0) {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(newUtmParams));
      setUtmParams(newUtmParams);
    } else {
      // Try to retrieve from session storage
      const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
      if (stored) {
        try {
          setUtmParams(JSON.parse(stored));
        } catch {
          // Invalid JSON, ignore
        }
      }
    }
  }, []);

  return utmParams;
};

export const buildCalendlyUrlWithUtm = (
  baseUrl: string,
  utmParams: UtmParams
): string => {
  const url = new URL(baseUrl);
  
  // Map UTM params to Calendly's expected format
  if (utmParams.utm_source) url.searchParams.set("utm_source", utmParams.utm_source);
  if (utmParams.utm_medium) url.searchParams.set("utm_medium", utmParams.utm_medium);
  if (utmParams.utm_campaign) url.searchParams.set("utm_campaign", utmParams.utm_campaign);
  if (utmParams.utm_term) url.searchParams.set("utm_term", utmParams.utm_term);
  if (utmParams.utm_content) url.searchParams.set("utm_content", utmParams.utm_content);

  return url.toString();
};
